import React from "react";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";
import { useCreateKioskoContext } from "../provider/createKiosko.provider";
import { useCreateNewsKioskoContext } from "../provider/createNewsKiosko.provider";
import { useCreateUsedKioskoContext } from "../provider/createUsedKiosko.provider";
import {
  useKioskoConfig,
  KioskoFlow,
} from "../../context/kiosko-config.context";
import { NewFlowIcon, UsedFlowIcon, BenefitFlowIcon } from "./flow-icons";

const SelectFlowComponent = () => {
  const config = useKioskoConfig();
  const { setFlow, setStep } = useCreateKioskoContext();
  const { handleInitialState: handleInitialStateNews } =
    useCreateNewsKioskoContext();
  const { handleInitialState: handleInitialStateUsed } =
    useCreateUsedKioskoContext();

  const handleResetState = (flow: KioskoFlow) => {
    setFlow(flow);
    handleInitialStateUsed();
    handleInitialStateNews();
    setStep(5);
  };

  // "benefit" se comporta igual que "new" (mismo device/pago); solo cambia la card.
  const cards: Record<
    KioskoFlow,
    { title: string; Icon: React.FC<{ className?: string }> }
  > = {
    new: { title: `Celulares ${config.name} (10%)`, Icon: NewFlowIcon },
    used: { title: "Celulares externos", Icon: UsedFlowIcon },
    benefit: { title: "Beneficio (1% - 2%)", Icon: BenefitFlowIcon },
  };

  const flows: KioskoFlow[] = config.flows?.length ? config.flows : ["new"];

  return (
    <div className="flex w-full flex-col items-center justify-center bg-transparent px-4">
      <div className="mt-4 flex w-full flex-col space-y-4 md:h-96 md:flex-row md:space-y-0 md:space-x-4">
        {flows.map((flow) => {
          const card = cards[flow];
          if (!card) return null;
          return (
            <div
              key={flow}
              className="flex min-h-64 w-full flex-1 flex-col items-center justify-center rounded-xl bg-white px-4 py-4 shadow-xl md:h-full md:py-2"
            >
              <div className="flex w-full flex-col items-center justify-center">
                <card.Icon className="my-4 h-28 w-28 md:my-6 md:h-40 md:w-40" />
                <h2 className="text-center text-2xl font-bold text-buttonBlack">
                  {card.title}
                </h2>
              </div>
              <PrimaryButton
                title="Seleccionar"
                className={
                  "mt-5 rounded-3xl bg-buttonBlack px-5 py-1 text-sm font-normal text-whiteSoft"
                }
                onClick={() => handleResetState(flow)}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SelectFlowComponent;
